import React from 'react';
import { useLayoutContext } from '../hooks/useLayoutContext';
export var LayoutContent = function (_a) {
    var children = _a.children;
    var currentLayout = useLayoutContext().currentLayout;
    return (React.createElement(React.Fragment, null, children &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        children.map(function (child) {
            if (child && child.props.currentLayout !== currentLayout)
                return null;
            return child;
        })));
};
//# sourceMappingURL=LayoutContent.js.map